export default __webpack_public_path__ + "locales/sq-AL/DowngradePlanDialog.json?hash=fcfbf68d1f2c09aa38ad5f24038ac5ef";